import { useQuery } from '@tanstack/react-query'
import { Link } from '@tanstack/react-router'
import { requetes } from '../api'
import { formaterInstant } from '../composants/Historique'
import { Icone } from '../composants/Icone'
import { Vide } from '../composants/Section'
import { EntetePage } from '../composants/Ui'

// Entrée du menu « Justificatifs » : les connexions au portail du cabinet (Tiime, Dougs), une par
// entité, chacune avec le nombre d'opérations à justifier (à choisir, à fournir) et menant à son
// bilan (/justificatifs/$id). Rien ne s'y décide.

export function JustificatifsConnexions() {
  const portails = useQuery(requetes.portails)
  const connexions = (portails.data?.connexions ?? [])
    .filter((c) => c.justificatifs !== null)
    .sort(
      (a, b) =>
        Number(b.active) - Number(a.active) || (a.entite ?? '').localeCompare(b.entite ?? ''),
    )

  return (
    <main>
      <EntetePage surtitre="Comptabilité" titre="Justificatifs" />
      <section className="carte section">
        <p className="discret">
          Rapprochement des opérations du cabinet avec les pièces de l’appli, entité par entité.
          Seul l’agent du Mac dépose et relie chez le cabinet, quand l’écriture est ouverte.
        </p>
        {portails.isPending && <Vide>Chargement…</Vide>}
        {portails.data && connexions.length === 0 && (
          <Vide>
            Aucune connexion au portail du cabinet : la créer dans{' '}
            <Link to="/reglages" search={{ onglet: 'connexions', connexion: 'portails' }}>
              Réglages, Portails
            </Link>
            .
          </Vide>
        )}
        {connexions.map((c) => (
          <Link
            key={c.id}
            to="/justificatifs/$id"
            params={{ id: c.id }}
            className="ligne ligne-lien"
          >
            <div className="ligne-contenu">
              <strong>{c.entite ?? 'Sans entité'}</strong>{' '}
              {c.justificatifs && c.justificatifs.aJustifier > 0 && (
                <span className="badge grand ton-ambre">
                  {c.justificatifs.aJustifier} à justifier
                </span>
              )}{' '}
              {!c.active ? (
                <span className="badge">Désactivée</span>
              ) : (
                <span className="badge">{c.ecritureActive ? 'Écriture ouverte' : 'À blanc'}</span>
              )}
              <div className="discret">
                {c.fournisseurLibelle} · {c.libelle}
              </div>
              <div className="discret">
                {c.collecte
                  ? 'Rapprochement en cours…'
                  : c.justificatifs?.dernier
                    ? `Dernier passage le ${formaterInstant(c.justificatifs.dernier.creeLe)}`
                    : 'Aucun passage encore'}
              </div>
            </div>
            <Icone nom="chevron_right" />
          </Link>
        ))}
      </section>
    </main>
  )
}
